<template>
  <div class="todo">
    <input
      class="todo__check"
      type="checkbox"
      :checked="todo.completed"
      @change="$emit('todo-change-completed', { value: !todo.completed, id: todo.id })"
    >

    <span
      v-if="readonly"
      class="todo__text"
    >
      {{ todo.text }}
    </span>
    <input
      v-else
      class="todo__text"
      type="text"
      placeholder="New todo"
      :class="{ 'todo__text--input': !readonly }"
      :value="todo.text"
      @input="$emit('todo-text-input', { value: $event.target.value, id: todo.id })"
    >

    <button
      v-if="!readonly"
      class="todo__btn-del"
      @click="$emit('todo-delete', todo.id)"
    />
  </div>
</template>

<script>
export default {
  name: 'Todo',

  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    todo: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/vars.styl'
@import '../css/mixins.styl'

.todo
  display flex
  align-items center

  &__check
    align-self flex-start
    margin-right 12px
    margin-top 2px
    width 18px
    height 18px
    position relative
    border-radius 4px

    &::before
    &::after
      content ''
      width 100%
      height 100%
      position absolute
      border 1px solid $primary
      background-color $primary
      border-radius 4px
      top -1px
      left -1px
      cursor pointer

    &::after
      transition $transition
      background url('~@/assets/icons/check.svg')
      transform scale(0) rotate(90deg)

    &:checked::after
      transform scale(1) rotate(0)

  &__text
    font-size 16px
    font-family 'Quicksand', sans-serif
    width 100%
    flex 1

    &--input
      border-bottom 1px solid $primary + 25%
      margin-bottom 8px

      &:focus
        border-color $white

  &__btn-del
    width 24px
    height @width
    background transparent url('~@/assets/icons/del.svg') center / 80% no-repeat
    margin-left 10px
    margin-top -10px
    cursor pointer

    &:hover
      background-image url('~@/assets/icons/del_r.svg')
</style>
